import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { constants, getFromLocalStorage } from './localStorage';

export const exportAsPicture = (id: string): any => {
  const isSecTable = id.includes('-secTablePng');
  id = id.replace('-secTablePng', '');
  const isDark = getFromLocalStorage(constants.darkMode);
  const html = document.getElementsByTagName('HTML')[0] as any;
  const body = document.getElementsByTagName('BODY')[0] as any;
  let htmlWidth = html.clientWidth;
  let bodyWidth = body.clientWidth;

  const data = document.getElementById(id) as any;
  if (isSecTable) {
    const Rows = data?.querySelectorAll('#secondaryTableRow');
    for (let index = 0; index < (Rows?.length as number); index++) {
      Rows?.[index].classList.add('secondaryTableRow');
    }
  }
  const newWidth = data?.scrollWidth - data?.clientWidth;

  if (newWidth > data?.clientWidth) {
    htmlWidth += newWidth;
    bodyWidth += newWidth;
  }

  html.style.width = htmlWidth + 'px';
  body.style.width = bodyWidth + 'px';
  //   window.scrollTo(0, 0);
  html2canvas(data, {
    scrollX: 0,
    width: id.includes('DataLabelChart')
      ? data?.clientWidth + 50
      : data?.clientWidth,
    scrollY: -window.scrollY,
    // letterRendering: 1,
    allowTaint: true,
    useCORS: true,
    logging: true,
    backgroundColor: isDark ? '#121826' : 'white',
  })
    .then((canvas: any) => {
      const image = canvas.toDataURL('image/png', 1.0);
      if (isSecTable) {
        const Rows = document?.querySelectorAll('#secondaryTableRow');
        for (let index = 0; index < Rows.length; index++) {
          Rows[index].classList.remove('secondaryTableRow');
        }
      }
      return image;
    })
    .then((image: any) => {
      saveAs(image, id + '.png');
      html.style.width = null;
      body.style.width = null;
    });
};
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const saveAs = (blob: any, fileName: any) => {
  const elem = document.createElement('a') as any;
  elem.href = blob;
  elem.download = fileName;
  elem.style = 'position:fixed';
  elem.style = 'display:none;';
  elem.style = 'overfollow:hidden;';
  elem.style = 'word-word:normal;';
  elem.style = 'text-align:right/left/canter/justify/auto';

  (document.body || document.documentElement).appendChild(elem);
  if (typeof elem.click === 'function') {
    elem.click();
  } else {
    elem.target = '_blank';
    elem.dispatchEvent(
      new MouseEvent('click', {
        view: window,
        bubbles: true,
        cancelable: true,
      }),
    );
  }
  URL.revokeObjectURL(elem.href);
  elem.remove();
};

// export const exportTweetAsPicture = (id: string) => {
//   setTimeout(() => {
//     const node = document.getElementById(id) as HTMLElement;
//     domtoimage.toPng(node, { cacheBust: true }).then((dataUrl) => {
//       const link = document.createElement('a');
//       link.download = id + '.png';
//       link.href = dataUrl;
//       link.click();
//     });
//   }, 2000);
// };

export const exportTreeAsPDF = async (
  id: string,
  type: string,
  name: string,
) => {
  const dataTotalImage = document.getElementById(id) as any;

  return await html2canvas(dataTotalImage, {
    allowTaint: true,
    useCORS: true,
    logging: true,
  }).then((canvas: any) => {
    const imgData = canvas.toDataURL('image/png', 1.0);

    const pdf = new jsPDF('l', 'px', [
      dataTotalImage?.clientWidth * 1.4,
      dataTotalImage?.clientHeight * 1.2,
    ]);
    pdf.addImage(
      imgData,
      'PNG',
      dataTotalImage?.clientWidth / 32,
      0,
      dataTotalImage?.clientWidth,
      dataTotalImage?.clientHeight,
    );
    pdf.save(`${name}-${id} (${type})` + '.pdf');
  });
};
export const exportMeshAsPDF = async (
  id: string,
  type: string,
  canvasRef: any,
  name: string,
) => {
  const dataTotalImage = document.getElementById(id) as any;

  const data = canvasRef.current.renderer();
  data.render(canvasRef.current.scene(), canvasRef.current.camera());

  return await html2canvas(dataTotalImage, {
    allowTaint: true,
    useCORS: true,
    logging: true,
  }).then((canvas: any) => {
    const imgData = canvas.toDataURL('image/png', 1.0);

    const pdf = new jsPDF('l', 'px', [
      dataTotalImage?.clientWidth * 1.4,
      dataTotalImage?.clientHeight * 1.2,
    ]);
    pdf.addImage(
      imgData,
      'PNG',
      dataTotalImage?.clientWidth / 32,
      0,
      dataTotalImage?.clientWidth,
      dataTotalImage?.clientHeight,
    );
    pdf.save(`${name}-${id} (${type})` + '.pdf');
  });
};
